import useConfig from '../../hooks/config.hooks';
import { ITranslations } from '../../i18n/config';

interface WidgetLink {
  title: ITranslations;
  description?: ITranslations;
  to: string;
  linkText: ITranslations;
}

export const useExternalLinks = () => {
  const { SORTING_STREET_URL, COMPANIES_URL } = useConfig();

  const links: WidgetLink[] = [
    {
      title: 'dashboard.widget.externalLinks.sortingStreet.title',
      description: 'dashboard.widget.externalLinks.sortingStreet.description',
      linkText: 'dashboard.widget.externalLinks.sortingStreet.linkText',
      to: SORTING_STREET_URL,
    },
    {
      title: 'dashboard.widget.externalLinks.companies.title',
      description: 'dashboard.widget.externalLinks.companies.description',
      linkText: 'dashboard.widget.externalLinks.companies.linkText',
      to: COMPANIES_URL,
    },
  ];

  return links;
};

export const useSettings = () => {
  const links: WidgetLink[] = [
    {
      title: 'preferences.title',
      description: 'preferences.description',
      linkText: 'dashboard.widget.mySettings.preferences.linkText',
      to: '/voorkeuren',
    },
    {
      title: 'newsletters.title',
      description: 'newsletters.description',
      linkText: 'dashboard.widget.mySettings.newsletters.linkText',
      to: '/nieuwsbrieven',
    },
  ];

  return links;
};
